import { Injectable } from '@angular/core';
import { PromotionApprovalApiService } from '@cms/apis';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { exhaustMap, map } from 'rxjs';
import { PromotionApprovalAction } from '../actions';

@Injectable()
export class PromotionApprovalEffect {
  loadItem$ = createEffect(() => {
    return this._actions$.pipe(
      ofType(PromotionApprovalAction.loadItem),
      exhaustMap(action => {
        return this._apiService.get(action.id).pipe(map(item => PromotionApprovalAction.loadItemSuccess({ item })));
      })
    );
  });
  constructor(private _apiService: PromotionApprovalApiService, private _actions$: Actions, private _store: Store) {}
}
